import styled from 'styled-components';
import { SYS_BREAKPOINT_2_XL, SYS_BREAKPOINT_LG, SYS_BREAKPOINT_MD, SYS_BREAKPOINT_SM, SYS_BREAKPOINT_XL, SYS_BREAKPOINT_XS, SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_300, SYS_SPACE_FIXED_350, SYS_SPACE_RELATIVE_BP_SM_SM, SYS_SPACE_RELATIVE_LG, SYS_SPACE_RELATIVE_SM, } from '@oneaudi/unified-web-common';
import { dynamicStyling, dynamicStylingHelper } from '../../../../utils';
import { SYS_COLOR_TEXT_HEADLINE_DEFAULT_DARK } from '@oneaudi/unified-web-alpha-common';
export const FinanceContainer = styled.div `
  margin-bottom: ${(props) => props.isPLP ? dynamicStylingHelper(SYS_SPACE_FIXED_350, SYS_SPACE_FIXED_300) : ''};
`;
export const PriceInformationContainer = styled.div ``;
export const RateWrapper = styled.div `
  display: flex;
  flex-grow: 1;
  margin: 0;
  align-items: center;
`;
export const PriceAndInfoIWrapper = styled.div `
  display: flex;
  align-items: center;
  flex-direction: row;
`;
export const RateNextToInfoI = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  & .apply-alpha-style {
    ${dynamicStyling({ alpha: `color: ${SYS_COLOR_TEXT_HEADLINE_DEFAULT_DARK}` })};
  }
`;
export const StyledPriceTextWrapper = styled.div `
  display: flex;
  align-items: center;
  min-height: 36px;
`;
export const AlertModal = styled.div `
  text-align: center;
  display: flex;
  flex-direction: column;
  min-height: 150px;
  justify-content: space-between;
`;
export const PriceWrapper = styled.div `
  justify-content: flex-start;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  row-gap: ${SYS_SPACE_RELATIVE_LG};

  ${dynamicStyling({
    legacy: `
    margin-bottom: ${SYS_SPACE_FIXED_350};
  `,
})};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    flex-direction: row;
    align-items: stretch;
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    align-items: flex-start;
    flex-direction: column;
  }

  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    flex-direction: row;
    align-items: stretch;
  }
  @media (min-width: ${SYS_BREAKPOINT_2_XL}) {
    // simplify this if PDP also want to stretch the price components
    ${(props) => `
    justify-content: ${props.isPLP && dynamicStylingHelper(false, true) ? 'space-between' : 'flex-start'};`};
  }
`;
export const SecondaryPriceWrapper = styled.div `
  margin-bottom: ${SYS_SPACE_RELATIVE_SM};
`;
export const RegularAndRetailPrice = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 0;
  min-height: 72px;

  & .apply-alpha-style {
    ${dynamicStyling({ alpha: `color: ${SYS_COLOR_TEXT_HEADLINE_DEFAULT_DARK}` })};
  }
`;
export const PriceDivider = styled.div `
  border-left: 2px solid ${SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT};
  padding-left: ${SYS_SPACE_RELATIVE_LG};
  margin-left: ${SYS_SPACE_RELATIVE_LG};
  display: none;

  &:first-child {
    display: none !important;
  }
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    display: block;
  }
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    display: none;
  }

  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    display: block;
  }
`;
export const MonthlyRateContainer = styled.div `
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
`;
export const DisclaimerWrapper = styled.div `
  @media (min-width: ${SYS_BREAKPOINT_XS}) {
    max-width: ${SYS_BREAKPOINT_XS};
  }
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    max-width: ${SYS_BREAKPOINT_SM};
  }
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    max-width: ${SYS_BREAKPOINT_SM};
  }
`;
export const DisclaimerContainer = styled.div `
  padding: ${dynamicStylingHelper(SYS_SPACE_FIXED_150, SYS_SPACE_RELATIVE_BP_SM_SM)} 0px 0px 0px;
`;
export const ChangeRateLink = styled.div `
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  margin-top: 30px;
`;
